<template>
    <div id="particles-js" class="d-flex justify-center fill-height">
        <v-container fluid style="position: absolute; width:fit-content">
            <v-card
                class="mx-auto pb-5 mt-5 rounded-xl"
                :style="isSmallScreen ? 'width: 300px' : 'width: 600px'"
                elevation="24"
                variant="elevated"
            >
                <v-toolbar
                    style="
                        background: linear-gradient(
                            90deg,
                            #3b3d4d 21%,
                            #242939
                        );
                        color: white;
                    "
                    dark
                    prominent
                    class="mb-5"
                >
                    <p class="text-h6 pl-5">Login</p>
                </v-toolbar>
                <v-row>
                    <v-col>
                        <div v-if="alert.show" class="mx-3">
                            <v-alert type="error">
                                <pre style="font-family: inherit">{{
                                        alert.message
                                    }}</pre>
                            </v-alert>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                        v-if="isSmallScreen"
                        cols="12"
                        class="d-flex pl-10 pr-5"
                    >
                        <v-img
                            max-height="150"
                            src="/images/d3_connect.jpg"
                            class="my-auto"
                        ></v-img>
                    </v-col>
                    <v-col v-else cols="6" class="d-flex pl-10 pr-5">
                        <v-img
                            max-height="150"
                            src="/images/d3_connect.jpg"
                            class="my-auto"
                        ></v-img>
                    </v-col>
                    <v-col class="pr-10 pl-5">
                        <form @submit.prevent="login">
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        label="Username"
                                        variant="outlined"
                                        v-model="form.username"
                                        type="text"
                                        color="primary"
                                    >
                                        <template v-slot:prepend-inner>
                                            <font-awesome-icon
                                                icon="fa-solid fa-user"
                                                class="mr-1"
                                            />
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        label="Password"
                                        variant="outlined"
                                        v-model="form.password"
                                        :type="
                                            showPassword ? 'text' : 'password'
                                        "
                                        color="primary"
                                        :append-icon="
                                            showPassword
                                                ? 'mdi:mdi-eye'
                                                : 'mdi:mdi-eye-off'
                                        "
                                        @click:append="
                                            showPassword = !showPassword
                                        "
                                    >
                                        <template v-slot:prepend-inner>
                                            <font-awesome-icon
                                                icon="fa-solid fa-key"
                                                class="mr-1"
                                            />
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-select
                                        label="Login Type"
                                        :items="['LDAP', 'Standard']"
                                        v-model="form.login_type"
                                        variant="underlined"
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-btn
                                        variant="elevated"
                                        block
                                        color="primary"
                                        class="rounded-lg"
                                        type="submit"
                                        :loading="formProcessing"
                                    >
                                        Login
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </form>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>

    </div>
</template>

<script>
import GuestLayout from "../../Layouts/GuestLayout.vue";
import ParticlesJS from 'particles.js'
import axios from "axios";

export default {
    layout: [GuestLayout],
    components:{ParticlesJS},
    data() {
        return {
            showPassword: false,

            form: {
                username: null,
                password: null,
                login_type: "LDAP",
            },
            formProcessing: false,
            alert: {
                show: false,
                message: "",
            },
            isSmallScreen: false,
        };
    },
    beforeCreate() {
        if (this.$page.props.auth.check)
            return (window.location.href = route("home"));
    },
    created() {

        this.updateScreenSize();
        window.addEventListener("resize", this.updateScreenSize);

    },
    mounted() {
        this.initParticles()
    },
    destroyed() {
        window.removeEventListener("resize", this.updateScreenSize);
    },
    methods: {
        login() {
            this.alert.message = "";
            this.alert.show = false;
            this.formProcessing = true;
            axios.get("/sanctum/csrf-cookie").then((response) => {
                axios
                    .post(route("login"), this.form)
                    .then((response) => {
                        // console.log(response.data.redirect)
                        window.location.href = response.data.redirect;
                    })
                    .catch((obj) => {
                        const status = obj.response.status;
                        if (status === 422) {
                            const errors = obj.response.data.errors;
                            Object.keys(errors).forEach((key) => {
                                this.alert.message += `${errors[key][0]}\n`;
                            });
                        }
                        if (status === 400) {
                            this.alert.message = obj.response.data.message;
                        }
                        this.alert.show = true;
                    })
                    .finally(() => {
                        this.formProcessing = false;
                    });
            });
        },
        updateScreenSize() {
            this.isSmallScreen = window.innerWidth <= 600;
        },
        initParticles() {

            particlesJS("particles-js", {
                particles: {
                    number: {
                        value: 6, // Number of bubbles
                        density: {
                            enable: true,
                            value_area: 800, // Area in which the bubbles are distributed
                        },
                    },
                    color: {
                        value: "#1b1e34", // Bubble color
                    },
                    shape: {
                        type: "circle", // Bubble shape
                        stroke: {
                            width: 0,
                            color: "#000",
                        },
                        polygon: {
                            nb_sides: 6,
                        },
                        image: {
                            src: "images/Logos/D3_Letterhead.png",
                            width: 100,
                            height: 100,
                        },
                    },
                    opacity: {
                        value: 0.3, // Transparency of bubbles
                        random: true,
                        anim: {
                            enable: false,
                            speed: 1,
                            opacity_min: 0.1,
                            sync: false,
                        },
                    },
                    size: {
                        value: 125, // Base size of bubbles
                        random: false,
                        anim: {
                            enable: true, // Animation for size
                            speed: 10,
                            size_min: 40, // Minimum bubble size
                            sync: false,
                        },
                    },
                    line_linked: {
                        enable: false, // Disable lines between bubbles
                    },
                    move: {
                        enable: true,
                        speed: 8, // Speed of bubble movement
                        direction: "none",
                        random: false,
                        straight: false,
                        out_mode: "out", // Bubbles will move out of bounds
                        bounce: false,
                        attract: {
                            enable: false,
                            rotateX: 600,
                            rotateY: 1200,
                        },
                    },
                },
                interactivity: {
                    detect_on: "canvas",
                    events: {
                        onhover: {
                            enable: false, // Disable hover effect
                        },
                        onclick: {
                            enable: false, // Disable click effect
                        },
                        resize: true,
                    },
                    modes: {
                        grab: {
                            distance: 400,
                            line_linked: {
                                opacity: 1,
                            },
                        },
                        bubble: {
                            distance: 400,
                            size: 40, // Bubble size when interacting
                            duration: 2,
                            opacity: 8, // Bubble opacity on interaction
                            speed: 3,
                        },
                        repulse: {
                            distance: 200,
                            duration: 0.4,
                        },
                        push: {
                            particles_nb: 4,
                        },
                        remove: {
                            particles_nb: 2,
                        },
                    },
                },
                retina_detect: true,
            });


        }
    },
};
</script>
<style scoped>
#particles-js {
    background-color: lightslategrey;

}
canvas {
    display:block;
    background: rgb(33,36,50);
    position: fixed;
    z-index: -1;
}

</style>
